var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPoint3Icon31(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "point3icon3-1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 93.995,
    height: 94,
    viewBox: "0 0 93.995 94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_110",
    "data-name": "\\u9577\\u65B9\\u5F62 110",
    width: 93.995,
    height: 94,
    fill: "#5f7cae"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_83",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 83",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_110",
    "data-name": "\\u30D1\\u30B9 110",
    d: "M57.254,79.286v9.2c.972,0,1.928-.035,2.88.007a2.8,2.8,0,0,1,2.9,2.706,2.733,2.733,0,0,1-2.826,2.771q-13.216.052-26.433,0A2.73,2.73,0,0,1,30.959,91.2a2.8,2.8,0,0,1,2.907-2.7c.9-.04,1.813-.007,2.844-.007v-9.2H34.67q-11.839,0-23.679,0C4.23,79.273,0,75.038,0,68.289Q0,39.562,0,10.835C0,4.281,4.244,0,10.747,0Q47,0,83.253,0C89.668,0,93.988,4.288,93.99,10.657q.009,29,0,58.005c0,6.239-4.347,10.593-10.627,10.616-8.016.029-16.031.007-24.046.007H57.254M46.964,5.506q-17.9,0-35.791,0c-3.961,0-5.665,1.716-5.666,5.7q0,28.357,0,56.714c0,4.18,1.682,5.842,5.915,5.843q35.607,0,71.214,0c4.183,0,5.851-1.689,5.851-5.908q0-28.265,0-56.531c0-4.184-1.664-5.818-5.916-5.818q-17.8,0-35.607,0m-4.5,82.853h9.015V79.381H42.46Z",
    transform: "translate(0 0)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_111",
    "data-name": "\\u30D1\\u30B9 111",
    d: "M57.36,75.077A17.5,17.5,0,1,1,75.08,57.854,17.519,17.519,0,0,1,57.36,75.077M54.806,46.188c-5.389.868-9.606,6.577-9.182,12.188A12.042,12.042,0,0,0,57.511,69.569c5.693-.033,11.094-4.305,11.442-9.242-3.476,0-6.942.009-10.407,0-2.844-.01-3.72-.876-3.736-3.715-.018-3.418,0-6.837,0-10.422m14.159,8.531c.06-3.612-5.565-8.919-8.5-8.389v8.389Z",
    transform: "translate(-25.364 -25.363)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_112",
    "data-name": "\\u30D1\\u30B9 112",
    d: "M126.239,122.486h8.895c.035-.637.1-1.28.1-1.922.011-3.118-.01-6.236.011-9.353.015-2.222.967-3.352,2.741-3.335,1.716.016,2.743,1.226,2.767,3.388.033,3.056.009,6.113.01,9.169V122.5h9.126c.03-.685.083-1.332.084-1.978.007-5.563,0-11.125.009-16.688.005-2.181,1-3.378,2.735-3.369,1.674.008,2.768,1.306,2.773,3.4q.025,10.361,0,20.723c-.006,2.438-1.025,3.52-3.432,3.527q-14.121.042-28.242,0c-2.289-.007-3.284-.982-3.345-3.2q-.09-3.3,0-6.6c.054-1.989,1.015-3.02,2.673-3.052,1.732-.033,2.716,1.038,2.806,3.112.053,1.22.043,2.443.075,3.665,0,.111.1.22.212.451",
    transform: "translate(-76.21 -63.578)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_113",
    "data-name": "\\u30D1\\u30B9 113",
    d: "M170.818,45.547c-2.32,0-4.641.025-6.961-.007-1.915-.027-3-1.02-3.021-2.676a2.69,2.69,0,0,1,2.928-2.813q7.144-.077,14.288,0a2.821,2.821,0,0,1,2.994,2.815c-.028,1.56-1.242,2.647-3.084,2.673-2.381.033-4.763.008-7.144.008",
    transform: "translate(-101.782 -25.321)",
    fill: "#5f7cae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_114",
    "data-name": "\\u30D1\\u30B9 114",
    d: "M50.333,160.763c2.32,0,4.64-.029,6.959.008,1.978.032,3,.965,3.029,2.648a2.665,2.665,0,0,1-2.913,2.828q-7.14.105-14.283,0a2.843,2.843,0,0,1-3.011-2.807c.017-1.539,1.243-2.643,3.078-2.671,2.38-.037,4.761-.009,7.142-.01",
    transform: "translate(-25.385 -101.73)",
    fill: "#5f7cae"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoint3Icon31);
export default __webpack_public_path__ + "static/media/point3icon3-1.ceb4d6159b350e84538a5c30c682e32f.svg";
export { ForwardRef as ReactComponent };